import { render, staticRenderFns } from "./Progreso.vue?vue&type=template&id=12b49a2a&"
import script from "./Progreso.vue?vue&type=script&lang=js&"
export * from "./Progreso.vue?vue&type=script&lang=js&"
import style0 from "./Progreso.vue?vue&type=style&index=0&id=12b49a2a&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports